import { render, staticRenderFns } from "./text-settings.vue?vue&type=template&id=f14d97f4&scoped=true&"
import script from "./text-settings.vue?vue&type=script&lang=js&"
export * from "./text-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f14d97f4",
  null
  
)

export default component.exports